import { CmsCategoryCodeEnum } from '~/src/models/enums/cms.enum';
import { getArticlesAttrCode, getArticlesDictionary } from '~/src/repositories/cms/shared/cms.base.repository';
import {
    getMappedMtsBankData,
} from '~/src/repositories/cms/entities/products/utils/cms.products.utils';
import { getMappedReferralData } from '~/src/repositories/cms/shared/utils/cms.utils';
import type { CmsMappedArticlesInterface } from '~/src/repositories/cms/types/cms.articles.types';

export const getMtsProductBySefUrl = async (
    isSSR: boolean,
    categoryCode: CmsCategoryCodeEnum,
    articleSefUrl?: string,
) => {
    const data = await getArticlesDictionary({
        isSSR,
        categoryCode,
        articleSefUrl,
    });

    if ('cmsFailed' in data) {
        return { cmsFailed: true };
    }

    return getMappedReferralData(data);
};

export const getMtsProductByAttr = async (isSSR: boolean, categoriesCode: CmsCategoryCodeEnum, attrCode?: string) => {
    const data = await getArticlesAttrCode({
        isSSR,
        categoriesCode,
        attrCode,
    });

    if ('cmsFailed' in data) {
        return { cmsFailed: true };
    }

    return getMappedMtsBankData(data as unknown as Array<CmsMappedArticlesInterface | Record<string, never>>);
};
